import { useEffect } from 'react';
import useAuth from './useAuth';
import { setIsTokenVerified } from '@/lib/redux/app.slice';
import { useAppDispatch } from '@/lib/redux/store';
import { tokenStore } from '@/lib/storage/TokenStore';

const _appAccessTokenOnce = tokenStore.getAppAccessToken();
const _firebaseAccessTokenOnce = tokenStore.getFirebaseAccessToken();

const useInitializeCheckUser = () => {
  const dispatch = useAppDispatch();
  const { handleLogout } = useAuth();

  // on Load
  useEffect(() => {
    const checkReadiness = async () => {
      const appAccessToken = tokenStore.getAppAccessToken();
      const firebaseAccessToken = tokenStore.getFirebaseAccessToken();
      if (!appAccessToken || !firebaseAccessToken) {
        await handleLogout();
      }
      dispatch(setIsTokenVerified(true));
    };
    checkReadiness();
  }, [handleLogout, dispatch]);
};

export default useInitializeCheckUser;
